import { Component } from '@angular/core';
import {HeroEmpresarialComponent} from "../hero-empresarial/hero-empresarial.component";
import {HeroTerapiaFisicaComponent} from "./hero-terapia-fisica/hero-terapia-fisica.component";
import {InfoComponent} from "../home/info/info.component";
import {ImportantTFTComponent} from "./important-tft/important-tft.component";
import {FooterPersonaComponent} from "../../app-persona/footer-persona/footer-persona.component";

@Component({
  selector: 'app-terapia-fisica-ytraumotologica',
  standalone: true,
  imports: [
    HeroEmpresarialComponent,
    HeroTerapiaFisicaComponent,
    InfoComponent,
    ImportantTFTComponent,
    FooterPersonaComponent,
  ],
  templateUrl: './terapia-fisica-ytraumotologica.component.html',
  styleUrl: './terapia-fisica-ytraumotologica.component.css'
})
export class TerapiaFisicaYTraumotologicaComponent {


}
